import { useMutation, gql } from '@apollo/client';
import useLocales from './data/useLocales';
import { useState, useEffect } from 'react';
import axios from 'axios';

const GQL_OUTBOUND_MUTATION = gql`
  mutation CreateOutbound(
    $systemId: ID
    $localUrl: String!
    $destinationUrl: String!
    $whereOnSite: String
    $category: String
    $sessionId: String
    $locale: String
  ) {
    createOutbound(
      systemId: $systemId
      localUrl: $localUrl
      destinationUrl: $destinationUrl
      whereOnSite: $whereOnSite
      category: $category
      sessionId: $sessionId
      locale: $locale
    ) {
      result
    }
  }
`;

const GQL_PAGEVIEW_MUTATION = gql`
  mutation AddPage(
    $url: String!
    $locale: String!
    $sessionId: String
    $objectType: String
    $objectIds: [String]
    $systemIds: [String]
    $landingPage: Boolean
    $referrer: String
    $userAgent: String
  ) {
    addPage(
      url: $url
      locale: $locale
      sessionId: $sessionId
      objectType: $objectType
      objectIds: $objectIds
      systemIds: $systemIds
      landingPage: $landingPage
      referrer: $referrer
      userAgent: $userAgent
    )
  }
`;

export default function useWithGA() {
  const [saveOutboundMutation] = useMutation(GQL_OUTBOUND_MUTATION);
  const [savePageViewMutation] = useMutation(GQL_PAGEVIEW_MUTATION);
  const { locale } = useLocales();
  //const [bwid, setBwid] = useState(null);

  // useEffect(() => {
  //   const fetchScriptAndGetCookie = async () => {
  //     try {
  //       const response = await axios.get(
  //         'https://scripts.businesswith.com/t.html',
  //         {
  //           withCredentials: true, // Important for cookies to be set
  //           headers: {
  //             Accept: 'text/html',
  //           },
  //         }
  //       );

  //       console.log('response', response.headers);

  //       const bwidHeader = response.headers['x-bwid'];
  //       setBwid(bwidHeader);
  //     } catch (error) {
  //       console.error('Error fetching script or reading cookie:', error);
  //     }
  //   };

  //   fetchScriptAndGetCookie();
  // }, []);

  const handleDataLayer = (dL) => {
    if (Object.keys(dL).length) {
      const dlObj = {
        ...dL,
      };

      if (!dlObj.event) {
        dlObj.event = dlObj.event_name;
      }

      delete dlObj.event_name;

      window.dataLayer?.push(dlObj);
    }
  };

  const trackOutboundLink = (e, url, cat, where, systemId, dataLayerObj) => {
    const dlObj = {
      ...dataLayerObj,
      event: 'outbound_click',
      system_category: cat,
      outbound_url: url,
    };

    window.dataLayer.push(dlObj);

    saveOutboundMutation({
      variables: {
        category: cat,
        systemId: systemId || null,
        localUrl: window.location.href,
        destinationUrl: url,
        whereOnSite: where || null,
        sessionId: sessionStorage.getItem('sessionId') || null,
        locale,
      },
    });
  };

  const savePageView = ({ type = null, ids = null, systemIds = [] } = {}) => {
    try {
      let isLandingPage = true;
      const landingPage = sessionStorage.getItem('landingPage');

      if (landingPage.includes('DONE')) {
        isLandingPage = false;
      } else {
        sessionStorage.setItem('landingPage', `DONE-${landingPage}`);
      }
      const data = {
        url: window.location.href,
        locale,
        sessionId: sessionStorage.getItem('sessionId'),
        objectType: type,
        objectIds: ids,
        systemIds,
        landingPage: isLandingPage,
        referrer: window.frames.top.document?.referrer,
        userAgent: window.navigator?.userAgent,
      };

      // Send the data to the iframe Use a 500ms timeout to ensure the iframe is loaded
      setTimeout(() => {
        const iframe = document.getElementById('bw-id-t');
        if (iframe && process.env.GATSBY_BW_ENV === 'prod') {
          iframe.contentWindow.postMessage(JSON.stringify(data), '*');
        }
      }, 500);

      savePageViewMutation({
        variables: data,
      });
    } catch (error) {
      console.error('Issue with SPV');
    }
  };

  return {
    handleDataLayer,
    trackOutboundLink,
    savePageView,
  };
}
